import React from 'react';
import { connect } from 'react-redux';
import { useIntl } from 'react-intl';
import {
  getColorByVariantPaperColor as getColorByMaterialVariantPaperColor,
  getColorByVariantRibbonColor as getColorByMaterialVariantRibbonColor
} from "pxc-editor-core/helpers/material";
import { setVariantColorModalOpen } from '@/actions';
import { changeColorSchemaThunk } from '@/actions/colorSchema';
import { RadioButtonsSelectModal } from '@/components';
import { getBuildedMatfileTemplate } from '@/helpers/matfile';

const VariantColorModal = props => {
  const { colorSchema, setVariantColorModalOpen, changeColorSchemaThunk } = props;
  const intl = useIntl();
  const header = intl.formatMessage({ id: 'debug.colorVariant', defaultMessage: 'Color variant' });
  const matfileTemplate = getBuildedMatfileTemplate();
  const { variants } = matfileTemplate;
  const list = variants.map(variant => ({ value: variant.article_number, label: variant.article_name }));

  const handleVariantChange = value => {
    const variant = variants.find(item => item.article_number === value);
    if (variant) {
      const paperColor = getColorByMaterialVariantPaperColor(variant);
      const ribbonColor = getColorByMaterialVariantRibbonColor(variant);

      changeColorSchemaThunk({ schema: variant, paperColor, ribbonColor });
    }
    handleClose();
  };

  const handleClose = () => {
    setVariantColorModalOpen(false);
  };

  return <RadioButtonsSelectModal open header={header} list={list} preselect={colorSchema.article_number} setOpen={handleClose} onChange={handleVariantChange} />;
};

const mapStateToProps = state => {
  return {
    colorSchema: state.core.colorSchema
  };
};

export default connect(mapStateToProps, { setVariantColorModalOpen, changeColorSchemaThunk })(VariantColorModal);
